import { useEffect, useState } from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';

import { getConsent, isEURegion, setConsent } from '@utils/cookieConsent';

const PRIVACY_POLICY_URL = 'https://qualz.ai/legal/privacy-policy';

const CookieConsentBanner = () => {
  const [open, setOpen] = useState(false);
  const [eu, setEu] = useState(false);

  useEffect(() => {
    if (getConsent()) return;
    setEu(isEURegion());
    setOpen(true);
  }, []);

  if (!open) return null;

  const handle = (status) => {
    setConsent(status);
    setOpen(false);
  };

  return (
    <Paper
      role="dialog"
      aria-live="polite"
      aria-label="Cookie preferences"
      elevation={8}
      sx={{
        position: 'fixed',
        zIndex: 1500,
        bottom: { xs: 12, md: 24 },
        right: { xs: 12, md: 24 },
        left: { xs: 12, md: 'auto' },
        maxWidth: { xs: 'auto', md: 420 },
        borderRadius: 3,
        p: { xs: 2.5, md: 3 },
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        border: '1px solid #E5E7EB',
      }}
    >
      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
          Cookies on Qualz.ai
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.55 }}>
          {eu
            ? "We use necessary cookies to run the dashboard and optional analytics cookies to understand how it's used. Analytics stay off until you accept."
            : "We use necessary cookies to run the dashboard and optional analytics cookies to understand how it's used. You can opt out anytime."}{' '}
          See our{' '}
          <a
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#7C3AED', fontWeight: 500, textDecoration: 'none' }}
          >
            Privacy Policy
          </a>
          .
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1.5 }}>
        <Button
          variant="outlined"
          onClick={() => handle('rejected')}
          sx={{
            flex: 1,
            textTransform: 'none',
            borderColor: '#E5E7EB',
            color: '#111827',
            fontWeight: 500,
            '&:hover': { borderColor: '#D1D5DB', backgroundColor: '#F9FAFB' },
          }}
        >
          Reject non-essential
        </Button>
        <Button
          variant="contained"
          onClick={() => handle('accepted')}
          sx={{
            flex: 1,
            textTransform: 'none',
            backgroundColor: '#7C3AED',
            fontWeight: 600,
            '&:hover': { backgroundColor: '#6D28D9' },
          }}
        >
          Accept all
        </Button>
      </Box>
    </Paper>
  );
};

export default CookieConsentBanner;
